export const courseSharedStyles = () => ({
  videoPaper: {
    padding: 20,
    borderRadius: '8px !important',
    background: 'linear-gradient(81deg, #D2F4FD -23.74%, #D2FAE9 122.1%)',
    maxWidth: 'clamp(620px, 95%, 55vw)',
  },
});
